import React, { useContext } from 'react';
import './Schedule.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardScheduleContext } from '../../contexts/CardScheduleContext';
import logComponent from '../../common/logComponent';

export default function ScheduleLoadingStatus({ reloadAction }) {
  const cardScheduleContext = useContext(CardScheduleContext);
  const { scheduleLoading, scheduleError } = cardScheduleContext;

  if (logComponent('ScheduleLoadingStatus')) { console.debug('ScheduleLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={scheduleLoading} isError={scheduleError} reloadAction={reloadAction} />
  );
}